import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import enTranslations from "../languages/en.json";
import frTranslations from "../languages/fr.json";

gsap.registerPlugin(ScrollTrigger);

// horizontal scroll

function toggleHorizontalScroll() {
  if (window.innerWidth < 992) {
    document.body.style.overflowX = "hidden";

    ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
  } else {
    document.body.style.overflowX = "auto";

    initScrollTrigger();
  }
}

gsap.to(".gallery-content-eikon-1", {
  scrollTrigger: {
    trigger: ".gallery-eikon-mask",
    start: "top top",
    end: "+=600%",
    pin: true,
    scrub: 2,
    // markers: true,
  },
  x: "-448%",
  ease: "sine.inOut",
});

function initScrollTrigger() {
  gsap.to(".gallery-content-free-1", {
    scrollTrigger: {
      trigger: ".gallery-free-mask",
      start: "top top",
      end: "+=600%",
      pin: true,
      scrub: 2,
      // markers: true,
    },
    x: "-528%",
    ease: "sine.inOut",
  });
}

toggleHorizontalScroll();

window.addEventListener("resize", toggleHorizontalScroll);

// horizontal scroll

// return previous page
const returnElement = document.getElementById("return");
if (returnElement) {
  returnElement.addEventListener("click", function (event) {
    event.preventDefault(); // Prevent the default link behavior
    history.back(); // Go back to the previous page
  });
}
// return previous page

// language switcher

document.addEventListener("DOMContentLoaded", async () => {
  const defaultLang = "fr";
  const savedLang = localStorage.getItem("selectedLanguage");
  const currentLang = savedLang || defaultLang;
  const langSwitcherBtns = document.querySelectorAll(".lang-switch");

  const useCorrectTranslation = (lang) => {
    const translations_map = {
      en: enTranslations,
      fr: frTranslations, // Si langue = "fr", on utilise frTranslations
    };
    const translationsData = translations_map[lang];
    const translations = document.querySelectorAll("[data-translation]");

    translations.forEach((translation) => {
      const key = translation.dataset.translation;

      if (translationsData[key]) {
        translation.innerHTML = translationsData[key];
      }
      const resumeLinks = document.querySelectorAll(".homepage-about-cv-link");

      resumeLinks.forEach(function (resumeLink) {
        resumeLink.href = `img/queru-louise-cv-${lang}.pdf`;
      });
    });
  };

  useCorrectTranslation(currentLang);

  langSwitcherBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      const newLang = btn.dataset.lang;
      localStorage.setItem("selectedLanguage", newLang);
      useCorrectTranslation(newLang);
    });
  });
});

// language switcher

// burger menu

var burger = document.querySelector(".nav-burger");
var menu = document.querySelector(".nav");

function toggleMenu() {
  console.log;
  menu.classList.toggle("is-active");
  burger.classList.toggle("is-active");
}

burger.addEventListener("click", toggleMenu);

// burger menu

const nav = document.querySelector(".nav");
const triggerSection = document.querySelector(".nav-no-bg");

if (nav && triggerSection) {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        nav.classList.add("no-bg");
      } else {
        nav.classList.remove("no-bg");
      }
    },
    {
      threshold: 0.6, // % de la section visible
    }
  );

  observer.observe(triggerSection);
}

// boutons de langue

const buttons = document.querySelectorAll(".lang-switch");
const savedLang = localStorage.getItem("lang");

buttons.forEach((b) => b.classList.remove("active"));

if (savedLang) {
  const activeBtn = document.querySelector(
    `.lang-switch[data-lang="${savedLang}"]`
  );
  if (activeBtn) activeBtn.classList.add("active");
} else {
  document
    .querySelector('.lang-switch[data-lang="fr"]')
    ?.classList.add("active");
}

buttons.forEach((btn) => {
  btn.addEventListener("click", () => {
    const lang = btn.dataset.lang;

    localStorage.setItem("lang", lang);

    buttons.forEach((b) => b.classList.remove("active"));
    btn.classList.add("active");
  });
});

// boutons de langue

// lightbox

const lightbox = GLightbox({
  selector: ".glightbox",
  loop: true,
});

// lightbox
